module.exports = __webpack_public_path__ + "static/img/rarr.1f96b78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rarr.svg
// module id = Wo66
// module chunks = 1